'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var kruxRequested = false;

exports.default = function () {
  if (kruxRequested) {
    return;
  }

  kruxRequested = true;

  (function () {
    var kruxTargeting = document.createElement('script');

    kruxTargeting.setAttribute('class', 'kxint');
    kruxTargeting.setAttribute('data-namespace', 'seekanz');
    kruxTargeting.type = 'text/javascript';
    kruxTargeting.innerHTML = 'window.Krux||((Krux=function(){Krux.q.push(arguments);}).q=[]);\n    (function(){\n      function retrieve(n){\n        var k= \'kx\'+\'seekanz_\'+n, ls=(function(){\n          try {\n            return window.localStorage;\n          } catch(e) {\n            return null;\n          }\n        })();\n        if (ls) {\n            return ls[k] || \'\';\n        } else if (navigator.cookieEnabled) {\n            var m = document.cookie.match(k+\'=([^;]*)\');\n            return (m && unescape(m[1])) || \'\';\n        } else {\n            return \'\';\n        }\n      }\n      Krux.user = retrieve(\'user\');\n      Krux.segments = retrieve(\'segs\') ? retrieve(\'segs\').split(\',\') : [];\n    })();';

    var head = document.getElementsByTagName('head')[0];

    head.appendChild(kruxTargeting);
  })();
};